import {
  KeyValuePipe,
  LowerCasePipe,
  NgTemplateOutlet,
  TitleCasePipe,
} from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatHeaderCell,
  MatTableModule,
} from '@angular/material/table';

import {
  BuildLinkFromValue,
  ChipTypePipe,
  ExtractValueFromPathPipe,
  GridCdkTableComponent, GridColumnCasePipe,
  GridFeatureWrapperDirective,
  GridMatTableComponent,
  GridPagComponent,
  GridTableComponent,
  GridViewsWrapperDirective,
  WcgAdvancedFiltersComponent,
  WcgChipModule,
  WcgFilterIndicatorsComponent,
  WcgInputFieldComponent,
  WcgPaginationComponent
} from "@wcg/frontend-framework";

import { AddressFormatPipe } from '@shared/pipes/address.pipe';


import { MatCardModule } from '@angular/material/card';
import {
  CreateGridViewActionsComponent,
  GridViewDownComponent,
} from '@data-access/grid-views';
import { GridActionsComponent } from '@data-access/grid-views/components/grid-actions/grid-actions.component';

import { ERMDateTimePipe } from '@shared/pipes/erm-date.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UiFilterWrapperComponent } from '../ui-components/ui-filter-wrapper/ui-filter-wrapper.component';
import { UiGridToggleGroupComponent } from '../ui-components/ui-segmented-toggle/ui-grid-toggle-group.component';

export const CONFIG_WRAPPER_IMPORTS = [
  AddressFormatPipe,
  BuildLinkFromValue,
  CdkDrag,
  CdkDragHandle,
  CdkDropList,
  CdkTableModule,
  CreateGridViewActionsComponent,
  ERMDateTimePipe,
  ExtractValueFromPathPipe,
  GridColumnCasePipe,
  GridFeatureWrapperDirective,
  GridMatTableComponent,
  GridTableComponent,
  GridCdkTableComponent,
  GridPagComponent,
  GridViewDownComponent,
  GridViewsWrapperDirective,
  KeyValuePipe,
  LowerCasePipe,
  MatCardModule,
  MatCell,
  MatCellDef,
  MatHeaderCell,
  MatIconModule,
  MatSortModule,
  MatSortModule,
  MatTableModule,
  NgTemplateOutlet,
  ReactiveFormsModule,
  RouterModule,
  TitleCasePipe,
  WcgAdvancedFiltersComponent,
  WcgChipModule,
  WcgFilterIndicatorsComponent,
  WcgInputFieldComponent,
  WcgPaginationComponent,
  GridActionsComponent,
  UiFilterWrapperComponent,
  UiGridToggleGroupComponent,
  ChipTypePipe,
  MatProgressSpinnerModule
];
